import { Modal as CModal, ModalProps as CModalProps } from '@chakra-ui/react'

export function Modal({ closeOnOverlayClick = false, ...props }: CModalProps) {
  return <CModal closeOnOverlayClick={closeOnOverlayClick} {...props} />
}
